/* ═══════════════════════════════════════════════════════════
   DECORLOFT — THEME JS
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {

  /* ═══════════════════════════════════════════════════════════
     HEADER: Scroll behavior
     ═══════════════════════════════════════════════════════════ */
  (function() {
    var hdr    = document.getElementById('dlhdr');
    var spacer = document.getElementById('dlhdr-spacer');
    var ann    = document.getElementById('dlann');
    var lastY  = 0;

    if (!hdr) return;

    function setSpacerHeight() {
      if (!spacer) return;
      var h = hdr.offsetHeight;
      var a = ann ? ann.offsetHeight : 0;
      spacer.style.height = (h + a) + 'px';
      document.documentElement.style.setProperty('--dl-header-total', (h + a) + 'px');
    }
    setSpacerHeight();
    window.addEventListener('resize', setSpacerHeight);

    window.addEventListener('scroll', function() {
      var y = window.scrollY;
      hdr.classList.toggle('dlhdr--scrolled', y > 10);
      hdr.classList.toggle('dlhdr--hidden', y > lastY && y > 120);
      lastY = y;
    }, { passive: true });
  })();


  /* ═══════════════════════════════════════════════════════════
     ANNOUNCEMENT BAR: Rotation
     ═══════════════════════════════════════════════════════════ */
  (function() {
    var msgs    = document.querySelectorAll('.dlann__msg');
    var current = 0;
    var timer;
    if (!msgs.length) return;

    function showMsg(idx) {
      msgs.forEach(function(m, i) {
        m.classList.toggle('dlann__msg--active', i === idx);
      });
    }

    function nextMsg() {
      current = (current + 1) % msgs.length;
      showMsg(current);
    }

    function prevMsg() {
      current = (current - 1 + msgs.length) % msgs.length;
      showMsg(current);
    }

    function resetTimer() {
      clearInterval(timer);
      timer = setInterval(nextMsg, 4000);
    }

    var prevBtn = document.getElementById('dlann-prev');
    var nextBtn = document.getElementById('dlann-next');
    if (prevBtn) prevBtn.addEventListener('click', function() { prevMsg(); resetTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { nextMsg(); resetTimer(); });

    resetTimer();
  })();


  /* ═══════════════════════════════════════════════════════════
     HEADER: Dropdown toggle
     ═══════════════════════════════════════════════════════════ */
  window.dlhdrToggleDrop = function(btn) {
    var item = btn.closest('.dlhdr__nav-item');
    if (!item) return;
    var open = item.classList.contains('dlhdr__nav-item--open');
    document.querySelectorAll('.dlhdr__nav-item--open').forEach(function(el) {
      el.classList.remove('dlhdr__nav-item--open');
      var b = el.querySelector('.dlhdr__nav-link--drop');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!open) {
      item.classList.add('dlhdr__nav-item--open');
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  document.addEventListener('click', function(e) {
    var drop = e.target.closest('.dlhdr__nav-item--drop');
    if (!drop) {
      document.querySelectorAll('.dlhdr__nav-item--open').forEach(function(el) {
        el.classList.remove('dlhdr__nav-item--open');
        var b = el.querySelector('.dlhdr__nav-link--drop');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });


  /* ═══════════════════════════════════════════════════════════
     HEADER: Language dropdown
     ═══════════════════════════════════════════════════════════ */
  window.dlhdrToggleLang = function(e) {
    var btn = e.currentTarget || e.target;
    var wrap = btn.closest('.dlhdr__lang, .dldrw__lang');
    if (!wrap) return;
    var isOpen = wrap.classList.toggle('dlhdr__lang--open');
    wrap.classList.toggle('dldrw__lang--open', isOpen);
    var b = wrap.querySelector('button');
    if (b) b.setAttribute('aria-expanded', isOpen);
  };

  window.dlhdrSetLang = function(code) {
    document.querySelectorAll('[data-lang]').forEach(function(el) {
      el.classList.remove('dlhdr__lang-option--active', 'dldrw__lang-opt--active');
      if (el.dataset.lang === code) {
        el.classList.add(el.closest('.dlhdr__lang') ? 'dlhdr__lang-option--active' : 'dldrw__lang-opt--active');
        el.setAttribute('aria-selected', 'true');
      } else {
        el.setAttribute('aria-selected', 'false');
      }
    });
    document.querySelectorAll('.dlhdr__lang-btn, .dldrw__lang-btn').forEach(function(btn) {
      var txt = btn.querySelector('span');
      if (txt) txt.textContent = code === 'ar' ? 'العربية' : 'English';
      else btn.childNodes[0].textContent = code === 'ar' ? 'AR' : 'EN';
    });
  };

  document.addEventListener('click', function(e) {
    var langContainer = e.target.closest('.dlhdr__lang, .dldrw__lang');
    document.querySelectorAll('.dlhdr__lang--open, .dldrw__lang--open').forEach(function(c) {
      if (c !== langContainer) {
        c.classList.remove('dlhdr__lang--open', 'dldrw__lang--open');
        var b = c.querySelector('button');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });
  });


  /* ═══════════════════════════════════════════════════════════
     HEADER: Search toggle
     ═══════════════════════════════════════════════════════════ */
  window.dlhdrToggleSearch = function() {
    var search = document.getElementById('dlhdr-search');
    var btn = document.getElementById('dlhdr-search-btn');
    if (!search) return;
    var open = search.classList.toggle('dlhdr__search--open');
    if (btn) btn.setAttribute('aria-expanded', open);
    if (open) {
      var input = document.getElementById('dlhdr-search-input');
      if (input) setTimeout(function() { input.focus(); }, 200);
    }
  };


  /* ═══════════════════════════════════════════════════════════
     MOBILE DRAWER
     ═══════════════════════════════════════════════════════════ */
  window.dlhdrOpenDrawer = function() {
    var drawer = document.getElementById('dlhdr-drawer');
    var burger = document.getElementById('dlhdr-burger');
    if (!drawer) return;
    drawer.classList.add('dldrw--open');
    drawer.setAttribute('aria-hidden', 'false');
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('dl-drawer-lock');
  };

  window.dlhdrCloseDrawer = function() {
    var drawer = document.getElementById('dlhdr-drawer');
    var burger = document.getElementById('dlhdr-burger');
    if (!drawer) return;
    drawer.classList.remove('dldrw--open');
    drawer.setAttribute('aria-hidden', 'true');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('dl-drawer-lock');
  };

  window.dldrwToggle = function(btn) {
    var item = btn.closest('.dldrw__item');
    if (!item) return;
    var open = item.classList.toggle('dldrw__item--open');
    btn.setAttribute('aria-expanded', open);
    var sub = item.querySelector('.dldrw__sub');
    if (sub) sub.setAttribute('aria-hidden', !open);
  };

  var drawerBackdrop = document.querySelector('.dldrw__backdrop');
  if (drawerBackdrop) drawerBackdrop.addEventListener('click', window.dlhdrCloseDrawer);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') window.dlhdrCloseDrawer();
  });


  /* ═══════════════════════════════════════════════════════════
     SCROLL REVEAL
     ═══════════════════════════════════════════════════════════ */
  (function() {
    if (!window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('dl-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.dl-reveal').forEach(function(el) {
      observer.observe(el);
    });
  })();


  /* ═══════════════════════════════════════════════════════════
     CAROUSEL ARROW NAVIGATION
     ═══════════════════════════════════════════════════════════ */
  document.querySelectorAll('[data-carousel]').forEach(function(wrap) {
    var track = wrap.querySelector('[data-carousel-track]');
    var prev  = wrap.querySelector('[data-carousel-prev]');
    var next  = wrap.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;

    prev.addEventListener('click', function() {
      var card = track.querySelector('.product-card');
      var w = card ? card.offsetWidth + parseFloat(getComputedStyle(track).gap || '0') : 260 + 16;
      track.scrollBy({ left: -w, behavior: 'smooth' });
    });

    next.addEventListener('click', function() {
      var card = track.querySelector('.product-card');
      var w = card ? card.offsetWidth + parseFloat(getComputedStyle(track).gap || '0') : 260 + 16;
      track.scrollBy({ left: w, behavior: 'smooth' });
    });
  });


  /* ═══════════════════════════════════════════════════════════
     PRODUCT GALLERY: Thumbnail switching
     ═══════════════════════════════════════════════════════════ */
  window.dlv2Thumb = function(btn) {
    var wrap = btn.closest('.dlv2__gallery');
    if (!wrap) return;
    var main = wrap.querySelector('.dlv2__main-img-el');
    if (!main) return;
    main.src = btn.dataset.src;
    main.alt = btn.dataset.alt || '';
    wrap.querySelectorAll('.dlv2__thumb').forEach(function(t) {
      t.classList.remove('dlv2__thumb--active');
    });
    btn.classList.add('dlv2__thumb--active');
  };


  /* ═══════════════════════════════════════════════════════════
     PRODUCT QUANTITY
     ═══════════════════════════════════════════════════════════ */
  window.dlv2Qty = function(delta) {
    var num = document.getElementById('dlv2-qty-num');
    var input = document.getElementById('dlv2-qty-input');
    if (!num) return;
    var val = parseInt(num.textContent) + delta;
    if (val < 1) val = 1;
    if (val > 99) val = 99;
    num.textContent = val;
    if (input) input.value = val;
    updateTierPricing(val);
  };


  /* ═══════════════════════════════════════════════════════════
     TIERED PRICING
     ═══════════════════════════════════════════════════════════ */
  var tiers = document.querySelectorAll('.dlv2__tier');
  tiers.forEach(function(tier) {
    tier.addEventListener('click', function() {
      tiers.forEach(function(t) { t.classList.remove('dlv2__tier--active'); });
      tier.classList.add('dlv2__tier--active');
      var qty = parseInt(tier.dataset.qty) || 1;
      var num = document.getElementById('dlv2-qty-num');
      var input = document.getElementById('dlv2-qty-input');
      if (num) num.textContent = qty;
      if (input) input.value = qty;
    });
  });

  function updateTierPricing(qty) {
    var activeTier = document.querySelector('.dlv2__tier--active');
    if (activeTier && parseInt(activeTier.dataset.qty) === qty) return;
    tiers.forEach(function(t) {
      t.classList.remove('dlv2__tier--active');
      if (parseInt(t.dataset.qty) === qty) t.classList.add('dlv2__tier--active');
    });
  }


  /* ═══════════════════════════════════════════════════════════
     GIFT PROGRESS BAR (Product page)
     ═══════════════════════════════════════════════════════════ */
  var gpFill     = document.querySelector('.dlv2__gp-fill');
  var gpMsg     = document.getElementById('dlv2-gp-msg-top');
  var gpPriceEl = document.getElementById('dlv2-price');

  if (gpFill) {
    updateGiftProgress();

    var observer = new MutationObserver(function() { updateGiftProgress(); });
    if (gpPriceEl) observer.observe(gpPriceEl, { characterData: true, childList: true, subtree: true });

    document.querySelectorAll('.dlv2__tier, .dlv2__qty-btn').forEach(function(el) {
      el.addEventListener('click', function() { setTimeout(updateGiftProgress, 50); });
    });
  }

  function updateGiftProgress() {
    if (!gpFill || !gpMsg) return;
    var priceText = gpPriceEl ? gpPriceEl.textContent.trim() : '';
    var price = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
    var qtyNum = document.getElementById('dlv2-qty-num');
    var qty = qtyNum ? parseInt(qtyNum.textContent) || 1 : 1;
    var total = price * qty;
    var threshold = 150;
    var pct = Math.min((total / threshold) * 100, 100);
    gpFill.style.width = pct + '%';

    if (total >= threshold) {
      gpMsg.innerHTML = "🎁 <strong>You've unlocked a Free Gift!</strong> Added at checkout";
    } else {
      gpMsg.innerHTML = "You're <strong>AED " + Math.round(threshold - total) + "</strong> away from a FREE Gift Box";
    }
  }


  /* ═══════════════════════════════════════════════════════════
     STICKY ATC
     ═══════════════════════════════════════════════════════════ */
  (function() {
    var sticky = document.querySelector('.dlv2__sticky');
    var atcSection = document.querySelector('.dlv2__atc-btn');
    if (!sticky || !atcSection) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        sticky.classList.toggle('dlv2__sticky--visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(atcSection);

    var stickyBtn = sticky.querySelector('.dlv2__sticky-btn');
    var mainAtc   = document.getElementById('dlv2-atc');
    if (stickyBtn && mainAtc) {
      stickyBtn.addEventListener('click', function() { mainAtc.click(); });
    }
  })();


  /* ═══════════════════════════════════════════════════════════
     WISHLIST TOGGLE
     ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.wishlist-btn, .dlv2__ctl-wishlist, .dlv2__rec-wishlist');
    if (!btn) return;
    e.preventDefault();
    var svg = btn.querySelector('svg');
    var active = btn.classList.toggle('wishlist-btn--active');
    if (svg) {
      svg.style.fill = active ? 'currentColor' : 'none';
    }
  });


  /* ═══════════════════════════════════════════════════════════
     CART BADGE — Server-authoritative sync
     ═══════════════════════════════════════════════════════════ */
  window.dlUpdateCartBadge = function() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        var badge = document.getElementById('dlhdr-cart-badge');
        if (badge) {
          badge.textContent = data.item_count;
          badge.classList.toggle('dlhdr__cart-badge--hidden', data.item_count === 0);
        }
      }
    };
    xhr.send();
  };

  /* ── Optimistic increment (instant UI feedback) ── */
  window.dlOptimisticIncrement = function() {
    var badge = document.getElementById('dlhdr-cart-badge');
    if (badge) {
      var count = parseInt(badge.textContent) || 0;
      badge.textContent = count + 1;
      badge.classList.remove('dlhdr__cart-badge--hidden');
    }
  };

  /* ═══════════════════════════════════════════════════════════
     QUICK ADD  —  Product card + CTL + AOV
     ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.card-action-btn--add, .quick-add, .dlv2__ctl-quick-add, .dlv2__ctl-micro-add, .dlv2__gu-add, .dlv2__aov-add');
    if (!btn) return;
    e.preventDefault();

    var doneClass = 'card-action-btn--add--done';
    if (btn.classList.contains('dlv2__ctl-quick-add')) doneClass = 'dlv2__ctl-quick-add--done';
    if (btn.classList.contains('dlv2__ctl-micro-add')) doneClass = 'dlv2__ctl-micro-add--done';
    if (btn.classList.contains('quick-add')) doneClass = 'quick-add--done';

    if (btn.classList.contains(doneClass)) return;
    btn.classList.add(doneClass);

    /* ── Instant optimistic update ── */
    dlOptimisticIncrement();

    /* ── Add to cart via AJAX ── */
    var variantId = btn.getAttribute('data-variant-id');
    if (variantId) {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      xhr.onload = function() {
        if (xhr.status === 200) {
          dlUpdateCartBadge();
          if (typeof dlcdRefresh === 'function') setTimeout(dlcdRefresh, 400);
        }
      };
      xhr.send(JSON.stringify({ id: parseInt(variantId), quantity: 1 }));
    }

    /* ── Visual feedback ── */
    var textEl = btn.tagName === 'BUTTON' ? btn : btn.querySelector('span, .quick-add-text');
    if (!textEl) textEl = btn;
    var orig = textEl.textContent || '';
    if (orig.length < 20) textEl.textContent = '✓ Added';

    /* ── Card success flash ── */
    if (card) {
      card.classList.add('product-card--added');
      setTimeout(function() { card.classList.remove('product-card--added'); }, 700);
    }

    /* ── Card-level "Added!" toast ── */
    var card = btn.closest('.product-card');
    if (card && !card.querySelector('.dl-card-toast')) {
      var toast = document.createElement('span');
      toast.className = 'dl-card-toast';
      toast.textContent = 'Added to cart!';
      card.appendChild(toast);
      setTimeout(function() {
        toast.classList.add('dl-card-toast--hide');
        setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
      }, 1500);
    }

    setTimeout(function() {
      btn.classList.remove(doneClass);
      if (textEl.textContent === '✓ Added') textEl.textContent = orig;
    }, 2000);
  });


  /* ═══════════════════════════════════════════════════════════
     FBT: Add Bundle
     ═══════════════════════════════════════════════════════════ */
  var fbtCta = document.getElementById('dlv2-fbt-cta');
  if (fbtCta) {
    fbtCta.addEventListener('click', function() {
      var items = document.querySelectorAll('.dlv2__fbt-item');
      var variantIds = [];
      items.forEach(function(item) {
        var vid = item.dataset.variantId;
        if (vid) { variantIds.push(parseInt(vid)); dlOptimisticIncrement(); }
      });
      if (!variantIds.length) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: variantIds.map(function(id) { return { id: id, quantity: 1 }; }) })
      }).then(function(r) {
        if (!r.ok) throw new Error();
        return r.json();
      }).then(function() {
        dlUpdateCartBadge();
      }).catch(function() {});
      var orig = fbtCta.textContent;
      fbtCta.textContent = '✓ Bundle Added!';
      fbtCta.style.background = 'var(--dl-sage)';
      setTimeout(function() {
        fbtCta.textContent = orig;
        fbtCta.style.background = '';
      }, 2000);
    });
  }


  /* ═══════════════════════════════════════════════════════════
     FAQ ACCORDION
     ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-faq-btn]');
    if (!btn) return;
    var item = btn.closest('[data-faq]');
    if (!item) return;
    var open = item.classList.toggle('dlv2__faq-item--open');
    var body = item.querySelector('[data-faq-body]');
    if (body) {
      if (open) {
        body.style.maxHeight = body.scrollHeight + 'px';
      } else {
        body.style.maxHeight = '0';
      }
    }
  });


  /* ═══════════════════════════════════════════════════════════
     CTL: Micro Add (individual)
     ═══════════════════════════════════════════════════════════ */
  window.dlv2CtlMicro = function(btn) {
    if (btn.classList.contains('dlv2__ctl-micro-add--done')) return;
    btn.classList.add('dlv2__ctl-micro-add--done');
    btn.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="10" height="10"><polyline points="2 6 5 9 10 3"/></svg> Added';
    dlOptimisticIncrement();
    var variantId = btn.getAttribute('data-variant-id');
    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      }).then(function(r) {
        if (r.ok) dlUpdateCartBadge();
      });
    }
    setTimeout(function() {
      btn.classList.remove('dlv2__ctl-micro-add--done');
      btn.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="10" height="10"><path d="M6 2v8M2 6h8"/></svg> Add';
    }, 2000);
  };


  /* ═══════════════════════════════════════════════════════════
     CTL: Add All
     ═══════════════════════════════════════════════════════════ */
  window.dlv2CtlAddAll = function(btn) {
    if (btn.disabled) return;
    var cards = document.querySelectorAll('.dlv2__ctl-card');
    btn.disabled = true;
    var orig = btn.innerHTML;
    btn.innerHTML = '✓ Added All!';
    btn.style.background = 'var(--dl-sage)';

    var items = [];
    cards.forEach(function(card) {
      var add = card.querySelector('.dlv2__ctl-micro-add');
      if (add && !add.classList.contains('dlv2__ctl-micro-add--done')) {
        add.classList.add('dlv2__ctl-micro-add--done');
        add.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" width="10" height="10"><polyline points="2 6 5 9 10 3"/></svg> Added';
        var vid = add.getAttribute('data-variant-id');
        if (vid) { items.push({ id: parseInt(vid), quantity: 1 }); dlOptimisticIncrement(); }
      }
    });

    if (items.length) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(r) {
        if (r.ok) dlUpdateCartBadge();
      });
    }

    setTimeout(function() {
      btn.innerHTML = orig;
      btn.style.background = '';
      btn.disabled = false;
    }, 2000);
  };


  /* ═══════════════════════════════════════════════════════════
     AOV: Add item
     ═══════════════════════════════════════════════════════════ */
  window.dlv2AovAdd = function(item) {
    var btn = item.querySelector('.dlv2__aov-add');
    var variantId = item.dataset.variantId;
    if (btn) {
      btn.style.background = 'var(--dl-sage)';
      btn.style.borderColor = 'var(--dl-sage)';
      var svg = btn.querySelector('svg');
      if (svg) svg.style.stroke = '#fff';
      setTimeout(function() {
        btn.style.background = '';
        btn.style.borderColor = '';
        if (svg) svg.style.stroke = '';
      }, 1500);
    }
    dlOptimisticIncrement();
    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      }).then(function(r) {
        if (r.ok) dlUpdateCartBadge();
      });
    }
  };


  /* ═══════════════════════════════════════════════════════════
     HERO SLIDER
     ═══════════════════════════════════════════════════════════ */
  (function() {
    var slider = document.getElementById('decorloft-hero-slider');
    var hdr = document.getElementById('dlhdr');

    /* ── Header background ── */
    if (slider && slider.dataset.headerTransparent === 'true') {
      if (hdr) hdr.classList.add('dlhdr--transparent');
    }

    if (!slider) return;

    var slides = slider.querySelectorAll('.dl-hero-slide');
    var dots   = slider.querySelectorAll('.dl-hero-slider__dot');
    var total  = slides.length;
    if (total < 2) return;

    var current  = 0;
    var autoplay = slider.dataset.autoplay === 'true';
    var interval = parseInt(slider.dataset.interval) || 5000;
    var timer;

    function goTo(idx) {
      if (idx < 0) idx = total - 1;
      if (idx >= total) idx = 0;
      slides.forEach(function(s, i) {
        s.classList.toggle('active', i === idx);
      });
      dots.forEach(function(d, i) {
        d.classList.toggle('active', i === idx);
        d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
      current = idx;
    }

    function nextSlide() { goTo(current + 1); }
    function prevSlide() { goTo(current - 1); }

    function startTimer() {
      if (!autoplay) return;
      stopTimer();
      timer = setInterval(nextSlide, interval);
    }
    function stopTimer() { clearInterval(timer); }
    function resetTimer() { stopTimer(); startTimer(); }

    /* Dot clicks */
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        goTo(parseInt(this.dataset.slide));
        resetTimer();
      });
    });

    /* Pause on hover/touch */
    slider.addEventListener('mouseenter', stopTimer);
    slider.addEventListener('mouseleave', startTimer);
    slider.addEventListener('touchstart', stopTimer, { passive: true });
    slider.addEventListener('touchend', startTimer);

    /* Keyboard */
    slider.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowRight') { nextSlide(); resetTimer(); }
      if (e.key === 'ArrowLeft')  { prevSlide(); resetTimer(); }
    });

    startTimer();
  })();

});


/* ═══════════════════════════════════════════════════════════
   CART DRAWER
   ═══════════════════════════════════════════════════════════ */
(function() {
  var drawer = document.getElementById('dlcd');
  var bodyLockClass = 'dl-drawer-lock';

  if (!drawer) return;

  /* ── Open / Close ─────────────────────────────────────── */
  window.dlcdOpen = function() {
    drawer.classList.add('dlcd--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add(bodyLockClass);
    dlcdFetch();
    setTimeout(function() {
      var close = drawer.querySelector('.dlcd__close');
      if (close) close.focus();
    }, 300);
  };

  window.dlcdClose = function() {
    drawer.classList.remove('dlcd--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(bodyLockClass);
  };

  var backdrop = drawer.querySelector('.dlcd__backdrop');
  if (backdrop) backdrop.addEventListener('click', dlcdClose);

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('dlcd--open')) {
      dlcdClose();
    }
  });


  /* ── Fetch cart data ──────────────────────────────────── */
  function dlcdFetch() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        dlcdRender(data);
      }
    };
    xhr.send();
  }


  /* ── Render cart items ────────────────────────────────── */
  function dlcdRender(data) {
    var itemsEl = document.getElementById('dlcd-items');
    var subtotalEl = document.getElementById('dlcd-subtotal');
    var badgeEl = document.getElementById('dlhdr-cart-badge');

    if (!itemsEl) return;

    if (badgeEl) {
      var count = data.item_count || 0;
      badgeEl.textContent = count;
      badgeEl.classList.toggle('dlhdr__cart-badge--hidden', count === 0);
    }

    if (data.item_count === 0) {
      itemsEl.innerHTML = '<div class="dlcd__empty" id="dlcd-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" width="40" height="40" aria-hidden="true"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>' +
        '<p>' + (typeof window.dlcdStrings !== 'undefined' && window.dlcdStrings.empty ? window.dlcdStrings.empty : 'Your cart is empty') + '</p>' +
        '<button class="dlcd__shop-btn" onclick="dlcdClose()">' + (typeof window.dlcdStrings !== 'undefined' && window.dlcdStrings.continue ? window.dlcdStrings.continue : 'Continue shopping') + '</button>' +
        '</div>';
      if (subtotalEl) subtotalEl.textContent = 'AED 0';
      dlcdUpdateGift(0);
      return;
    }

    var template = document.getElementById('dlcd-item-template');
    var tplHtml = template ? template.innerHTML : '';
    var html = '';

    data.items.forEach(function(item) {
      var itemHtml = tplHtml
        .replace(/\{\{KEY\}\}/g, item.key)
        .replace(/\{\{IMAGE\}\}/g, item.image)
        .replace(/\{\{NAME\}\}/g, item.product_title)
        .replace(/\{\{URL\}\}/g, item.url)
        .replace(/\{\{VARIANT\}\}/g, item.variant_title || '')
        .replace(/\{\{QTY\}\}/g, item.quantity)
        .replace(/\{\{PRICE\}\}/g, 'AED ' + (item.line_price / 100).toFixed(0));
      html += itemHtml;
    });

    itemsEl.innerHTML = html;

    if (subtotalEl) {
      var total = data.items_subtotal_price || data.total_price || 0;
      subtotalEl.textContent = 'AED ' + (total / 100).toFixed(0);
    }

    var totalPrice = (data.items_subtotal_price || data.total_price || 0) / 100;
    dlcdUpdateGift(totalPrice);
  }


  /* ── Update gift progress (multi-tier) ─────────────────── */
  function dlcdUpdateGift(total) {
    var fillEl = document.getElementById('dlcd-gp-fill');
    var msgEl  = document.getElementById('dlcd-gp-msg');
    if (!fillEl || !msgEl) return;

    var tiersAttr = (drawer.getAttribute('data-gift-tiers') || '99,149,199,249').split(',');
    var tiers = [];
    for (var ti = 0; ti < tiersAttr.length; ti++) {
      tiers.push(parseFloat(tiersAttr[ti]));
    }
    var maxTier = tiers[tiers.length - 1] || 249;

    var pct = Math.min((total / maxTier) * 100, 100);
    fillEl.style.width = pct + '%';

    var dots = document.querySelectorAll('.dlcd__gp-dot');
    var unlocked = 0;
    var next = 0;
    for (var di = 0; di < tiers.length; di++) {
      if (total >= tiers[di]) {
        unlocked++;
        if (dots[di]) dots[di].classList.add('is-active');
      } else {
        if (dots[di]) dots[di].classList.remove('is-active');
        if (next === 0) next = tiers[di];
      }
    }

    if (total >= maxTier) {
      msgEl.innerHTML = '<strong>All gifts unlocked!</strong> Added at checkout';
    } else if (next > 0) {
      var remain = Math.round(next - total);
      msgEl.innerHTML = 'Add <strong>AED ' + remain + '</strong> more to unlock your next gift';
    } else {
      msgEl.innerHTML = 'Spend <strong>AED ' + tiers[0] + '+</strong> to unlock your first gift';
    }
  }


  /* ── Change quantity ──────────────────────────────────── */
  window.dlcdQty = function(key, delta) {
    var item = drawer.querySelector('.dlcd__item[data-key="' + key + '"]');
    if (!item) return;
    var numEl = item.querySelector('.dlcd__qty-num');
    if (!numEl) return;
    var qty = parseInt(numEl.textContent) + delta;
    if (qty < 1) { dlcdRemove(key); return; }
    if (qty > 99) qty = 99;
    numEl.textContent = qty;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/change.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        dlcdRender(data);
      }
    };
    xhr.send(JSON.stringify({ id: key, quantity: qty }));
  };


  /* ── Remove item ──────────────────────────────────────── */
  window.dlcdRemove = function(key) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/cart/change.js', true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function() {
      if (xhr.status === 200) {
        var data = JSON.parse(xhr.responseText);
        dlcdRender(data);
      }
    };
    xhr.send(JSON.stringify({ id: key, quantity: 0 }));
  };


  /* ── Public refresh helper ────────────────────────────── */
  window.dlcdRefresh = function() {
    if (drawer.classList.contains('dlcd--open')) {
      dlcdFetch();
    }
  };

  document.addEventListener('cart:updated', function() { dlcdRefresh(); });
  document.addEventListener('ajaxProduct:added', function() { dlcdRefresh(); });

  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.card-action-btn--add, .quick-add, .dlv2__ctl-quick-add, .dlv2__ctl-micro-add, .dlv2__gu-add, .dlv2__aov-add, .dlv2__fbt-cta, .dl-sets__card-cta');
    if (btn) {
      setTimeout(dlcdRefresh, 800);
    }
  });


  /* ═══════════════════════════════════════════════════════════
     PRODUCT CARD  —  Click anywhere to navigate
     ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var card = e.target.closest('.product-card');
    if (!card) return;
    var ignore = e.target.closest('a, button, .card-action-btn, .wishlist-btn, .quick-add, .product-card-hover-actions');
    if (ignore) return;
    var url = card.getAttribute('data-product-url');
    if (url) { e.preventDefault(); window.location.href = url; }
  });


  /* ═══════════════════════════════════════════════════════════
     UGC VIDEOS  —  Play / Pause / Carousel / ATC
     ═══════════════════════════════════════════════════════════ */
  document.querySelectorAll('[data-ugc]').forEach(function(section) {
    var track = section.querySelector('[data-ugc-track]');
    var prev  = section.querySelector('[data-ugc-prev]');
    var next  = section.querySelector('[data-ugc-next]');
    if (!track) return;

    /* ── Arrow navigation ── */
    if (prev && next) {
      prev.addEventListener('click', function() {
        var card = track.querySelector('.dl-ugc__card');
        if (!card) return;
        var w = card.offsetWidth + parseFloat(getComputedStyle(track).gap || '0');
        track.scrollBy({ left: -w, behavior: 'smooth' });
      });
      next.addEventListener('click', function() {
        var card = track.querySelector('.dl-ugc__card');
        if (!card) return;
        var w = card.offsetWidth + parseFloat(getComputedStyle(track).gap || '0');
        track.scrollBy({ left: w, behavior: 'smooth' });
      });
    }

    /* ── Video play/pause (native <video> only) ── */
    section.addEventListener('click', function(e) {
      var card = e.target.closest('[data-ugc-card]');
      if (!card) return;
      var video = card.querySelector('video[data-ugc-video]');
      if (!video) return;

      if (e.target.closest('.dl-ugc__atc')) return;

      if (video.paused) {
        section.querySelectorAll('video[data-ugc-video]').forEach(function(v) {
          if (v !== video && !v.paused) {
            v.pause();
            var c = v.closest('[data-ugc-card]');
            if (c) c.classList.remove('is-playing');
          }
        });
        video.play().then(function() {
          card.classList.add('is-playing');
        }).catch(function() {});
      } else {
        video.pause();
        card.classList.remove('is-playing');
      }
    });

    /* ── Auto-pause on scroll out of view ── */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            var video = entry.target.querySelector('video[data-ugc-video]');
            if (video && !video.paused) {
              video.pause();
              entry.target.classList.remove('is-playing');
            }
          }
        });
      }, { threshold: 0 });
      section.querySelectorAll('[data-ugc-card]').forEach(function(card) {
        observer.observe(card);
      });
    }

    /* ── Quick add to cart ── */
    section.querySelectorAll('.dl-ugc__atc').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var vid = btn.getAttribute('data-variant-id');
        if (!vid) return;
        if (btn.classList.contains('is-added')) return;

        dlOptimisticIncrement();

        var xhr = new XMLHttpRequest();
        xhr.open('POST', '/cart/add.js', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        xhr.onload = function() {
          if (xhr.status === 200) {
            dlUpdateCartBadge();
            if (typeof dlcdRefresh === 'function') setTimeout(dlcdRefresh, 400);
          }
        };
        xhr.send(JSON.stringify({ id: parseInt(vid), quantity: 1 }));

        btn.classList.add('is-added');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><polyline points="20 6 9 17 4 12"/></svg>';
        setTimeout(function() {
          btn.classList.remove('is-added');
          btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="14" height="14"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        }, 2000);
      });
    });
  });


  /* ═══════════════════════════════════════════════════════════
     Curated Sets — Add Bundle
     ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.dl-sets__card-cta');
    if (!btn) return;
    if (btn.disabled) return;

    var items = [];
    [1, 2, 3].forEach(function(i) {
      var vid = btn.getAttribute('data-variant-' + i);
      if (vid) items.push({ id: parseInt(vid), quantity: 1 });
    });
    if (!items.length) return;

    btn.disabled = true;
    var origText = btn.textContent;
    btn.textContent = 'Adding\u2026';

    items.forEach(function() { dlOptimisticIncrement(); });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    }).then(function() {
      btn.textContent = '\u2713 Bundle Added!';
      btn.style.background = 'var(--dl-sage)';
      dlUpdateCartBadge();
      setTimeout(function() {
        btn.disabled = false;
        btn.textContent = origText;
        btn.style.background = '';
      }, 2500);
    }).catch(function() {
      btn.disabled = false;
      btn.textContent = origText;
    });
  });

})();